// extracted by mini-css-extract-plugin
export default {"notfound":"notfound_notfound__q4WkB","notfound-text":"notfound_notfound-text__GmgWF","notfound-btn":"notfound_notfound-btn__3QMHI"};